var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBlock = function SvgBlock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6673 7.99992C14.6673 11.6819 11.682 14.6666 8.00065 14.6666C4.31865 14.6666 1.33398 11.6819 1.33398 7.99992C1.33398 4.31859 4.31865 1.33325 8.00065 1.33325C11.682 1.33325 14.6673 4.31859 14.6673 7.99992ZM8.94351 8.00018L11.237 5.70698C11.4963 5.44699 11.4963 5.02365 11.237 4.76365C10.977 4.50432 10.5537 4.50432 10.2937 4.76365L8.00046 7.05712L5.70698 4.76365C5.44765 4.50432 5.02365 4.50432 4.76432 4.76365C4.50498 5.02365 4.50498 5.44699 4.76432 5.70698L7.05751 8.00018L4.76432 10.2937C4.50498 10.553 4.50498 10.977 4.76432 11.2363C5.02365 11.4957 5.44765 11.4957 5.70698 11.2363L8.00046 8.94312L10.2937 11.2363C10.5537 11.4957 10.977 11.4957 11.237 11.2363C11.4963 10.977 11.4963 10.553 11.237 10.2937L8.94351 8.00018Z",
    fill: "currentColor"
  })));
};
export default SvgBlock;